export const TIN_AND_GA_FORM_ID = 'tin-and-ga-form';
